package com.hyperether.goodjob.scenes.contacts.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Divider
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import com.hyperether.goodjob.models.Contact
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.delete
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource

@Composable
fun EditContactsDialog(
    showDialog: Boolean,
    contactList: List<Contact>,
    onDelete: () -> Unit,
    onExportList: () -> Unit,
    onImportList: () -> Unit
) {
    if (showDialog) {
        Box(
            modifier = Modifier
                .width(300.toScaleDp())
                .clickable(
                    indication = null,
                    interactionSource = remember { MutableInteractionSource() },
                    onClick = { }
                )
                .padding(16.toScaleDp())
                .background(Color.White, shape = RoundedCornerShape(8.toScaleDp()))
            //.shadow(1.toScaleDp(), RoundedCornerShape(8.toScaleDp()))
        ) {
            Column {
                Text(
                    text = "${contactList.size} selected",
                    fontWeight = FontWeight.Bold,
                    fontSize = 16.toScaleSp(),
                    modifier = Modifier.padding(
                        start = 16.toScaleDp(),
                        end = 16.toScaleDp(),
                        top = 16.toScaleDp()
                    )
                )

                Spacer(modifier = Modifier.height(8.toScaleDp()))

                Divider(
                    color = Color.LightGray,
                    thickness = 1.toScaleDp()
                )

                Spacer(modifier = Modifier.height(8.toScaleDp()))

                Row(
                    horizontalArrangement = Arrangement.SpaceBetween,
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(
                            start = 16.toScaleDp(),
                            end = 16.toScaleDp(),
                            bottom = 16.toScaleDp()
                        )
                        .clickable {
                            onDelete()
                        }
                ) {
                    Text(
                        text = stringResource(Res.string.delete),
                        fontSize = 14.toScaleSp(),
                        color = Color.Red)
//                    Text(
//                        text = stringResource(Res.string.export_list),
//                        fontSize = Sp(14f),
//                        color = BlueApp,
//                        modifier = Modifier.clickable {
//                            onExportList()
//                        })
//                    Text(
//                        text = stringResource(Res.string.import_list),
//                        fontSize = Sp(14f),
//                        color = BlueApp,
//                        modifier = Modifier.clickable {
//                            onImportList()
//                        })
                }
            }
        }
    }
}